document.addEventListener('DOMContentLoaded', function () {
  function triggerAvadaValidation() {
    if (typeof window.avadaOrderLimits === 'function') {
      window.avadaOrderLimits(); // Trigger Avada's validation
    }
  }

  // Listen for updates in the Qikify Slide Cart
  document.body.addEventListener('qikify:cart:updated', function () {
    triggerAvadaValidation();
  });
});
